module.exports = __webpack_public_path__ + "static/media/avatar2.d8459cb4.png";